<template>
  <aside class="request-detail-activity" data-testid="request-detail-activity">
    <p class="request-detail-activity__heading">Activity</p>

    <div class="request-detail-activity__body">
      <div v-if="loading" class="request-detail-activity__loading" data-testid="request-detail-activity__loading">
        <v-progress-circular indeterminate color="primary" size="28" />
      </div>

      <p
        v-else-if="entries.length === 0"
        class="request-detail-activity__empty"
        data-testid="request-detail-activity__empty"
      >
        No activity yet.
      </p>

      <div v-else class="request-detail-activity__timeline">
        <div
          v-for="(entry, index) in entries"
          :key="`${entry.date}-${entry.time}-${index}`"
          class="request-detail-activity__entry"
          :data-testid="`request-detail-activity__entry--${index}`"
        >
          <div class="request-detail-activity__line">
            <div class="request-detail-activity__dot">{{ entry.avatarLetters }}</div>
            <div
              class="request-detail-activity__line-bottom"
              :class="{ 'request-detail-activity__line-bottom--visible': index !== entries.length - 1 }"
            />
          </div>

          <div class="request-detail-activity__content">
            <p class="request-detail-activity__action">
              <strong v-if="entry.role">{{ entry.role }}</strong>
              <span>{{ entry.role ? ` ${entry.action}` : entry.action }}</span>
            </p>
            <p class="request-detail-activity__meta-time">{{ entry.date }}  ·  {{ entry.time }}</p>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import './RequestDetailActivity.scss';

export default {
  name: 'RequestDetailActivity',
  props: {
    resourceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      loglist: [],
    };
  },
  computed: {
    entries() {
      return this.loglist.map((log) => {
        const user = log.userid_detail || {};
        const userName = user.name || '';
        const userEmail = user.contactemail || user.email || '';
        const dt = new Date(log.created_at);
        const action = log.text || log.type || 'Activity';

        const initials = userName
          .split(/\s+/)
          .filter(Boolean)
          .slice(0, 2)
          .map((part) => part.charAt(0).toUpperCase())
          .join('') || '?';

        return {
          action,
          role: userName,
          email: userEmail,
          avatarLetters: initials,
          time: this.$nova.formatDateTime
            ? this.$nova.formatDateTime(dt, 'hh:mm A')
            : dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          date: this.$nova.formatDateTime
            ? this.$nova.formatDateTime(dt, 'DD MMM YYYY')
            : dt.toLocaleDateString([], { day: '2-digit', month: 'short', year: 'numeric' }),
        };
      });
    },
  },
  watch: {
    resourceId: {
      immediate: true,
      handler(id) {
        if (id) this.loadActivity();
      },
    },
  },
  methods: {
    async loadActivity() {
      if (!this.resourceId) return;
      this.loading = true;
      this.loglist = [];
      try {
        const result = await this.$store.dispatch('fetchActivityLog', {
          resourceId: this.resourceId,
        });
        this.loglist = result?.data || [];
      } catch {
        this.loglist = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
